import { useSpring, animated } from '@react-spring/web';
import { getAssetSrc } from '@restworld/utils-common';
import Image from 'next/image';
import { useEffect, useState } from 'react';
export type MapLoaderProps = {
  isLoading: boolean;
};

export const MapLoader = ({ isLoading }: MapLoaderProps) => {
  const [phaseIndex, setPhaseIndex] = useState(0);
  const icons = [
    getAssetSrc('/utils-assets/map-frame-one.svg'),
    getAssetSrc('/utils-assets/map-frame-three.svg'),
    getAssetSrc('/utils-assets/map-frame-four.svg'),
  ];

  const springProps = useSpring({
    loop: isLoading,
    from: { phaseIndex },
    to: async (next) => {
      while (isLoading) {
        await next({ phaseIndex: (phaseIndex + 1) % icons.length });
        await new Promise((resolve) => setTimeout(resolve, 20)); // Delay between transitions
        setPhaseIndex((phaseIndex + 1) % icons.length);
      }
    },
    config: { tension: 280, friction: 20 },
  });

  useEffect(() => {
    if (isLoading) {
      springProps.phaseIndex.start();
    }
  }, [isLoading, springProps.phaseIndex]);

  if (!isLoading) {
    return null; // Don't render anything when isLoading is false
  }

  return (
    <animated.div className="w-10 h-10 inline-block relative">
      <Image className="absolute left-0 top-0" src={icons[phaseIndex]} alt="Map loader" width={40} height={40} />
    </animated.div>
  );
};
